import { z } from 'zod';

export const memberSchema = z.object({
  phone_number: z
    .string()
    .min(11, 'شماره تلفن باید ۱۱ رقم باشد')
    .max(11, 'شماره تلفن باید ۱۱ رقم باشد')
    .regex(/^09[0-9]{9}$/, 'شماره تلفن معتبر نیست'),
  role: z.enum(['viewer', 'admin'], {
    errorMap: () => ({
      message: 'نقش باید بازدیدکننده یا مدیر باشد',
    }),
  }),
});
